// @ts-strict-ignore
import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import {setOptState} from '../opt';
import {deactivateTracking} from '../tracking';
import {template} from './template';
import css from './index.inline.styl';

type State = {
  hidden: boolean;
};

export class GdprBanner extends Component<State> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'mp23-brand': `boolean`,
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {hidden: true},
      helpers: {
        onAccept: () => {
          setOptState(`in`, `tracking`);
          setOptState(`in`, `storage`);
          this.dismiss();
        },
        onDismiss: () => {
          setOptState(`out`, `tracking`);
          setOptState(`out`, `storage`);
          this.dismiss();
        },
      },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    window.gdprData?.waitUntilReady().then(() => {
      if (window.gdprData.showBanner) {
        this.show();
      } else {
        this.dismiss();
      }
    });
  }

  show() {
    // deactivate tracking by default while banner is present; will be re-activated on opt-in
    deactivateTracking();
    this.update({hidden: false});
  }

  dismiss() {
    this.update({hidden: true});

    window.setTimeout(() => {
      this.parentNode?.removeChild(this);
    }, 400); // remove after fadeout animation
  }
}

export const GdprBannerEl = defineAndMakeJsxFactory(`mp-gdpr-banner`, GdprBanner);
